import React, {useState} from 'react'

export default function useForm (initialData) {

    const [values, setValues] = useState(initialData);
  
    const handleChange = (event) => {
        //event.persist();
        setValues({ ...values, [event.target.name]: event.target.value });
    };
  
    return [
        values,
        setValues,
        handleChange
    ]
  };